import get from "lodash/get";
import { useHistory as useReactRouterHistory } from 'react-router';
import { useEffect } from "react";
var useHashRouter = true;
var localHistory = null;
export function useMemoryRouterHistory() {
    var nextHistory = useReactRouterHistory();
    useEffect(function () {
        var history = localHistory;
        localHistory = nextHistory;
        useHashRouter = false;
        return function () {
            useHashRouter = true;
            localHistory = history;
        };
    }, []);
}
;
var normalizeURL = function (url) {
    var parsedURL = new URL(url);
    var getDomain = function (hostname) { return hostname.split(".").slice(-2).join("."); };
    if (getDomain(parsedURL.hostname) !== getDomain(window.location.hostname))
        return url;
    return new URL(url.replace(parsedURL.origin, ""), window.location.origin).href;
};
var doRedirect = function (url) {
    var _a;
    try {
        if ((_a = get(window, "websail.onRedirect")) === null || _a === void 0 ? void 0 : _a(url)) {
            return;
        }
    }
    catch (_b) { }
    ;
    return window.location.href = url;
};
export var redirectToPage = function (url, state) {
    var _a;
    if (state === void 0) { state = {}; }
    var _b = state.stripUrlPath, stripUrlPath = _b === void 0 ? false : _b, _c = state.integrationUrl, integrationUrl = _c === void 0 ? "" : _c, _d = state.skipParams, skipParams = _d === void 0 ? false : _d;
    if (!url)
        return;
    if (stripUrlPath) {
        if (integrationUrl && url.startsWith(integrationUrl) && integrationUrl.startsWith("/"))
            url = getHashOrPath(url.replace(integrationUrl, ""));
        try {
            url = new URL(url).hash;
        }
        catch (_e) { }
    }
    if (url.startsWith("//"))
        url = window.location.protocol + url;
    if (url.startsWith("http"))
        return doRedirect(normalizeURL(url));
    if (url.startsWith("/"))
        return doRedirect(url);
    if (!skipParams) {
        var search = new URL(window.location.hash.substr(1), window.location.origin).search;
        url = !((_a = url.split("#")[1]) === null || _a === void 0 ? void 0 : _a.includes("?")) ? url + search : (url + "&" + search.substr(1));
    }
    if (!localHistory)
        window.location.hash = url;
    else {
        if (!useHashRouter)
            url = url.replace(/#/g, "");
        localHistory.push(url);
    }
};
export var getHashOrPath = function (route, integrationUrl) {
    if (integrationUrl === void 0) { integrationUrl = ""; }
    if (integrationUrl)
        return integrationUrl + route;
    if (route.startsWith("/"))
        return "#" + route;
    return route;
};
